import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface INameProps {
  title: string;
  name: React.ReactElement;
}

export const Name = ({ title, name }: INameProps) => {
  return (
    <div className={styles['section']}>
      <div className={styles['subtitle']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['name']}>{name}</div>
    </div>
  );
};
